export const movieCategories = [
  { slug: "action", name: "动作", icon: "ri-sword-line", desc: "拳拳到肉的动作大片，追逐、爆破与硬核对决", color: "accent" },
  { slug: "scifi", name: "科幻", icon: "ri-planet-line", desc: "探索未来世界与浩瀚宇宙的想象之作", color: "primary" },
  { slug: "drama", name: "剧情", icon: "ri-book-open-line", desc: "细腻刻画人性与生活的深度故事", color: "secondary" },
  { slug: "comedy", name: "喜剧", icon: "ri-emotion-happy-line", desc: "轻松解压，让你开怀大笑的欢乐时刻", color: "accent" },
  { slug: "romance", name: "爱情", icon: "ri-heart-3-line", desc: "关于心动与遗憾的温柔叙事", color: "accent" },
  { slug: "mystery", name: "悬疑", icon: "ri-magic-line", desc: "步步反转，烧脑推理的谜题之旅", color: "primary" },
  { slug: "animation", name: "动画", icon: "ri-gamepad-line", desc: "天马行空的动画世界，全年龄的浪漫", color: "secondary" },
  { slug: "horror", name: "恐怖", icon: "ri-ghost-line", desc: "惊悚刺激，直击神经的恐怖体验", color: "secondary" },
  { slug: "war", name: "战争", icon: "ri-shield-star-line", desc: "烽火年代里关于信仰与牺牲的史诗", color: "primary" },
];

export const regions = ["全部", "中国大陆", "中国香港", "美国", "日本", "韩国", "英国", "法国"];

export const decades = ["全部", "2025", "2024", "2023", "2022", "2021", "2020"];